// extracted by mini-css-extract-plugin
module.exports = {"text_and_grid__container":"text_and_grid__container___-3w8dOjrQa1SD9VW73a6FcA","text_and_grid__carousel":"text_and_grid__carousel___-2dTirIOLj07Isfm1w0NnXD"};